module.exports = __webpack_public_path__ + "img/coverLogo.cdaff1d8.png";